export const Partners = [
	{
		id: "BDPS",
		name: "Roof Top Realty",
		logo: "/assets/companyLogos/RTRE_logo.svg",
		footerCopy: {
			line1: "© 2026 Roof Top Realty.",
			line2: "All Rights Reserved.",
			line3: "",
		},
		jobRequestCopy: "Create work order",
		vendorListHeading: "Vendor Categories",
		vendorListSubHeading:
			"Review the 125+ categories we serve and request to be connected with a Vendor.",
		vendorNavText: "Vendors",
		vendorTextSingular: "Vendor",
		contactEmail: "cole@rooftoprealty.com",
		jobRequestHeader: "Work Orders",
		jobRequestText: "work orders",
		jobRequestTextSingular: "work order",
		jobRequestHeaderSingular: "Work Order",
	},
]
